import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 6l6 6l-6 6","key":"svg-0"}]]

const IconChevronRight = createReactComponent('outline', 'chevron-right', 'ChevronRight', __iconNode);

export default IconChevronRight;